import { atom } from "recoil";

export const actionNotifyTextState = atom({
  key: "actionNotifyTextState",
  default: "",
});
